import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  topBar: {
    padding: "2px 2px",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  topBarError: {
    backgroundColor: "#fadede52",
    color: "#840606",
  },
  topBarInfo: {
    backgroundColor: "#d1ecf152",
    color: "#0c5460",
  },
  topBarWarning: {
    backgroundColor: "#f7eec952",
    color: "#846e06",
  },
  topBarSuccess: {
    backgroundColor: "#eaf7c952",
    color: "#618406",
  },
  stack: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    pointerEvents: "none",
    zIndex: 9999,
    display: "flex",
    flexDirection: "column-reverse",
  },
}));

type BannerType = "error" | "info" | "warning" | "success";

function typeClass(classes: ReturnType<typeof useStyles>, type: BannerType) {
  if (type === "error") return classes.topBarError;
  if (type === "info") return classes.topBarInfo;
  if (type === "warning") return classes.topBarWarning;
  return classes.topBarSuccess;
}

/** One row inside {@link AppBottomBannerStack}; use when stacking multiple bottom messages. */
export function AppBottomBannerRow({
  message,
  type = "error",
}: {
  message?: string;
  type?: BannerType;
}) {
  const classes = useStyles();
  if (!message) return null;
  return (
    <div className={`${classes.topBar} ${typeClass(classes, type)}`}>{message}</div>
  );
}

/** Fixed container for multiple bottom banners (column-reverse: first child is closest to the screen bottom). */
export function AppBottomBannerStack({ children }: { children: React.ReactNode }) {
  const classes = useStyles();
  return <div className={classes.stack}>{children}</div>;
}

export function AppTopBar({
  error_message,
  type = "error",
}: {
  error_message?: string;
  type?: BannerType;
}) {
  const classes = useStyles();

  if (!error_message) return null;

  return (
    <div className={classes.stack}>
      <AppBottomBannerRow message={error_message} type={type} />
    </div>
  );
}
